import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import {BrowserRouter} from 'react-router-dom';
import {WobiThemeProvider} from 'wobi-web-common';
import {IntlProvider} from 'react-intl';
import TagManager from 'react-gtm-module';
import {agentDeveloperUtils} from 'wobi-web-common/dist/components/utils/helpers';
import App from './App';
import messages_he from './messages/he.json';
import rollbar from './config/rollbar';


const defaultLanguage = 'he';
const messages = {
  he: messages_he,
};

window.rollbar = rollbar;

const gtmEnvironment = {
  gtmId: agentDeveloperUtils.getGtmId(),

  // auth: 'KMg6xM1_0hkSiQgb2GloKg',
  // preview: 'ENV-253'
};

TagManager.initialize(gtmEnvironment);
const AdditionalGtmIdArr = agentDeveloperUtils.getAdditionalTagManegerIds();
if (AdditionalGtmIdArr && Array.isArray(AdditionalGtmIdArr) && AdditionalGtmIdArr.length > 0) {
   
  for (const additionalGtmId of AdditionalGtmIdArr) {
    const additionalGtmEnviroment = {
      gtmId: additionalGtmId,
    };
    TagManager.initialize(additionalGtmEnviroment);
  }
}
const root = createRoot(document.querySelector('#root'));

root.render(
  <IntlProvider locale={defaultLanguage} messages={messages[defaultLanguage]}>
    <WobiThemeProvider>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </WobiThemeProvider>
  </IntlProvider>
);